import { ErroRespostaHttp } from '../../../shared/api/http';
import type { CampoConteudo, Valor } from '../../conteudo/api/conteudo';
import { svg } from '../../participantes/ui/MenuDeAcoes';

/** O que as telas de fase em Configurações (Scan Pixel, Laboratório) têm em comum. */

export const LIXEIRA = svg(<path d="M4 7h16M10 11v6M14 11v6M5 7l1 13h12l1-13M9 7V4h6v3" />);
export const SETA = svg(<path d="M6 9l6 6 6-6" />);

export type Aviso = { tipo: 'sucesso' | 'erro'; texto: string };

export function mensagemDaFalha(erro: unknown): string {
    if (erro instanceof ErroRespostaHttp) {
        if (erro.status === 401 || erro.status === 403) return 'Sessão expirada ou sem permissão. Entre de novo.';
        const mensagem = erro.corpo?.mensagem;
        if (typeof mensagem === 'string' && mensagem) return mensagem;
    }
    return 'Não foi possível salvar tudo. O que já foi salvo continua; confira e tente de novo.';
}

/** O texto digitado no tipo do campo: inteiro vira número, e o opcional vazio vira «sem valor». */
export function valorTipado(campo: CampoConteudo, digitado: string): Valor {
    if (campo.tipo === 'inteiro') return Number(digitado);
    if (campo.tipo === 'inteiro_opcional') return digitado.trim() === '' ? null : Number(digitado);
    if (campo.tipo === 'chave') return digitado === 'true';
    return digitado;
}

export const chaveDoCampo = (campo: CampoConteudo) => `${campo.entidade}:${campo.id}:${campo.campo}`;

/** O rótulo na tela; o do tempo encurta o do servidor ("vazio = sem cronômetro" vira o placeholder). */
const rotuloDe = (campo: CampoConteudo) => (campo.campo === 'tempo_segundos' ? 'Tempo (segundos)' : campo.rotulo);

interface CampoDoConteudoProps {
    campo: CampoConteudo;
    valor: string;
    travado: boolean;
    aoMudar: (valor: string) => void;
}

/** Um campo do conteúdo no controle do tipo dele: texto curto, número ou texto longo. */
export function CampoDoConteudo({ campo, valor, travado, aoMudar }: CampoDoConteudoProps) {
    const numero = campo.tipo === 'inteiro' || campo.tipo === 'inteiro_opcional';
    const longo = campo.tipo === 'paragrafo' || campo.tipo === 'texto_longo';
    return (
        <label className={`campo-config${numero ? ' campo-config-curto' : ''}`}>
            {rotuloDe(campo)}
            {longo && <textarea rows={3} value={valor} disabled={travado} onChange={(evento) => aoMudar(evento.target.value)} />}
            {numero && (
                <input
                    type="number"
                    placeholder={campo.tipo === 'inteiro_opcional' ? 'Sem cronômetro' : undefined}
                    value={valor}
                    disabled={travado}
                    onChange={(evento) => aoMudar(evento.target.value)}
                />
            )}
            {!numero && !longo && <input type="text" value={valor} disabled={travado} onChange={(evento) => aoMudar(evento.target.value)} />}
        </label>
    );
}
